import { render } from "./CarSearchComponent.vue?vue&type=template&id=528e672f&ts=true"
import script from "./CarSearchComponent?vue&type=script&lang=ts"
export * from "./CarSearchComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__